import Api from '../Base'

class PostShelfProduct extends Api {
  requestUrl = `/api/shelfProduct`

  method = 'POST'
}

export default PostShelfProduct
